import React from 'react';
import { useAppData } from '../../context/AppDataContext';
import useStorePlan from '../../hooks/useStorePlan';
import BrandThemeProvider from '../../theme/BrandThemeProvider';
import { useCachedBrandColors } from '../../theme/brandColorCache';

/** Themes the management shell with the selected store's brand colours (Pro only). */
const ManagementBrandTheme = ({ children }) => {
  const { currentStore } = useAppData();
  const storeId = currentStore?.id ?? null;
  const { entitlements } = useStorePlan(storeId, Boolean(storeId));
  const resolved = Boolean(storeId && entitlements);
  const allowed = entitlements?.allowsCustomBranding === true;
  const colors = useCachedBrandColors(
    storeId,
    allowed ? currentStore?.brandColors : null,
    resolved,
  );

  return (
    <BrandThemeProvider colors={colors} scope="store">
      {children}
    </BrandThemeProvider>
  );
};

export default ManagementBrandTheme;
